var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1495 22.0126C21.0484 21.9283 20.9937 21.8862 20.9431 21.8398C19.043 19.9391 17.1429 18.0385 15.2428 16.1378C15.0532 15.9482 14.9521 15.7417 15.0238 15.4719C15.1333 15.0463 15.6304 14.8609 15.9928 15.1137C16.056 15.1601 16.1149 15.2149 16.1697 15.2697C18.0656 17.1661 19.9615 19.0626 21.8573 20.959C21.8995 21.0011 21.9332 21.0601 21.9711 21.1107C21.9964 21.1149 22.0216 21.1234 22.0469 21.1276C22.0806 21.0728 22.1017 21.0096 22.1438 20.9674C24.0439 19.0583 25.9524 17.1535 27.8567 15.2444C28.0379 15.0632 28.2443 14.9536 28.5055 15.0168C28.9648 15.1264 29.1459 15.6574 28.8552 16.024C28.8131 16.0788 28.7625 16.1252 28.7162 16.1715C26.8245 18.0638 24.9329 19.956 23.037 21.8482C22.9949 21.8904 22.9401 21.9283 22.8348 22.0168C22.919 22.0674 22.9822 22.0884 23.0286 22.1306C24.9371 24.0355 26.8456 25.9446 28.7541 27.8494C28.9353 28.0306 29.0448 28.2371 28.9774 28.4984C28.8679 28.9494 28.3455 29.1348 27.9789 28.8567C27.9199 28.8103 27.8694 28.7597 27.8188 28.7049C25.9272 26.8127 24.0355 24.9205 22.1438 23.0282C22.1017 22.9861 22.0722 22.9271 22.0259 22.8639C21.9458 22.9397 21.9037 22.9819 21.8573 23.024C19.953 24.9415 18.0445 26.8464 16.136 28.7555C15.9548 28.9367 15.7484 29.0421 15.483 28.9789C15.0406 28.8735 14.851 28.3636 15.1207 27.9969C15.1628 27.9379 15.2176 27.8874 15.2681 27.8326C17.164 25.9361 19.0599 24.0397 20.9557 22.1432C21.0063 22.1011 21.0653 22.0716 21.1495 22.0126Z",
    fill: "#6160DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderCloseIcon);
export default __webpack_public_path__ + "static/media/slider-close-icon.274b731faa265d55cf720a4a618215a9.svg";
export { ForwardRef as ReactComponent };